module.exports = __webpack_public_path__ + "static/media/bot-avatar-Leo.7170ebe2.png";